/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryEvent
 */
export interface CategoryEvent {
    /**
     * 
     * @type {number}
     * @memberof CategoryEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryEvent
     */
    name: string;
}

/**
 * Check if a given object implements the CategoryEvent interface.
 */
export function instanceOfCategoryEvent(value: object): value is CategoryEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CategoryEventFromJSON(json: any): CategoryEvent {
    return CategoryEventFromJSONTyped(json, false);
}

export function CategoryEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CategoryEventToJSON(json: any): CategoryEvent {
    return CategoryEventToJSONTyped(json, false);
}

export function CategoryEventToJSONTyped(value?: CategoryEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

